<section id="section03">

    <div class="container">

        <div class="row d-flex justify-content-center align-items-center">
            <div class="col-lg-8">
                <div class="section-header">
                    <h2>{{ data.TITULO }}</h2>
                </div>
            </div>
        </div>

        <div class="row d-flex justify-content-center align-items-start">
            <div class="mt-4 col-lg-4">
                <div *ngFor="let detalhe of data.DETALHES" class="mb-3">
                    <div class="section03header"><i class="fa fa-angle-right fa-lg mr-2"></i> {{ detalhe.HEADER }}</div>
                    <div class="section03body">{{ detalhe.TEXTO }}</div>
                </div>
            </div>    

            <div class="mt-4 col-lg-8">
                <div class="card" [routerLink]="[ data.VIDEO.URL ] | localize">
                    <div class="card-body">
                        <div class="d-flex justify-content-center align-items-center">
                            <i class="fas fa-play-circle fa-4x icon-preview font-weight-bold text-white"></i>
                            <img src="{{ data.VIDEO.IMAGEM }}" alt="{{ data.VIDEO.DESCRICAO }}" title="{{ data.VIDEO.DESCRICAO }}" class="img-fluid">                            
                        </div>
                    </div>
                </div>
            </div>    
        </div>

    </div>

</section>